import type { StyleProps } from "@ecco/ui/types";

export const styles = {
    box: {
        position: "relative",
        boxShadow: "2xl",
    },
    wrapper: {
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        height: "200px",
        backgroundColor: "white",
        p: 4,
        gap: 2,
        h: "fit-content",
    },
    title: {
        mt: 4,
        mb: 1,
        fontSize: "lg",
        fontWeight: "bold",
    },
    buttonsWrapper: {
        w: "full",
        gap: 0.2,
    },
    button: {
        flexGrow: 1,
    },
} satisfies Record<string, StyleProps>;
